import React from 'react';
import Icon, { type Size } from '@atlaskit/icon';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import ComponentTypesMetadata from '../../common/ui/component-types-metadata/index.tsx';
import { ComponentIconBackground } from './component-icon-background/index.tsx';

export const ComponentTypeIcon = (props: {
	type: keyof typeof ComponentTypesMetadata;
	testId?: string;
	size?: Size;
}): React.JSX.Element => {
	const { type: providedType, testId, size = 'medium' } = props;
	const { formatMessage } = useIntl();
	const type = !providedType.startsWith('ari:cloud:compass') ? providedType : 'OTHER';
	const componentType = ComponentTypesMetadata[type] ?? ComponentTypesMetadata.OTHER;

	return (
		<Tooltip content={formatMessage(componentType.name)}>
			<ComponentIconBackground testId={testId} type={type} size={size}>
				{/* eslint-disable-next-line @atlaskit/design-system/no-custom-icons */}
				<Icon
					label={formatMessage(componentType.name)}
					primaryColor={token('color.icon.inverse')}
					glyph={componentType.icon}
				/>
			</ComponentIconBackground>
		</Tooltip>
	);
};
